// FUNCIONES GLOBALES - UNA SOLA VEZ
window.manejarCookieCodigoPostal = function (valor) {
  let nombreCookie = "dotoCodigoPostal";
  if (valor === undefined) {
    let cookieValor = document.cookie
      .split("; ")
      .find((row) => row.startsWith(nombreCookie + "="));
    return cookieValor ? cookieValor.split("=")[1] : null;
  } else if (valor === null) {
    document.cookie =
      nombreCookie + "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
  } else {
    document.cookie = nombreCookie + "=" + valor + "; path=/;";
  }
};

window.resetAlertGlobal = function () {
  var alerta = document.getElementById("alertPopupCP");
  if (alerta) {
    alerta.removeAttribute("class");
    alerta.innerHTML = "";
    alerta.style.display = "none";
  }

  var formCP = document.querySelector(".formCodigoPostal");
  if (formCP) formCP.style.borderColor = "#CFC4BE";

  var iconPath = document.querySelector(
    ".containerFormCP .icon-doto-search path",
  );
  if (iconPath) iconPath.style.fill = "#FF8C00";

  var iconClose = document.querySelector(".iconCloseModal");
  if (iconClose) iconClose.style.display = "none";
};

// FUNCIÓN PARA CAMBIAR ESTADOS DEL INPUT
function setInputState(state) {
  var formContainer = document.getElementById("formCodigoPostal");
  var iconSuccess = document.getElementById("iconSuccess");
  var iconError = document.getElementById("iconError");
  var iconLoading = document.getElementById("iconLoading"); 

  if (!formContainer || !iconSuccess || !iconError || !iconLoading) return;

  formContainer.classList.remove("success", "error");
  iconSuccess.style.display = "none";
  iconError.style.display = "none";
  iconLoading.style.display = "none";

  if (state === "loading") {
    iconLoading.style.display = "flex";
  } else if (state === "success") {
    formContainer.classList.add("success");
    iconSuccess.style.display = "flex";
  } else if (state === "error") {
    formContainer.classList.add("error");
    iconError.style.display = "flex";
  }
}

// FUNCIÓN PARA OBTENER PRECIO
function getPrecio() {
  var precioElement = document.querySelector(
    ".product__price .price-item--regular",
  );
  if (precioElement) {
    var precioTexto = precioElement.textContent
      .replace("$", "")
      .replace(",", "");
    return parseFloat(precioTexto) || 0;
  }
  return 0;
}

// FUNCIÓN PRINCIPAL DE CÁLCULO
async function calculaFechaEntrega(input, cookieCP = null) {
  var alerta = document.getElementById("alertPopupCP");

  setInputState("loading");

  let cp = "";

  if (cookieCP == null && input) {
    cp = input.value;
    input.value = input.value.slice(0, 5);

    var iconClose = document.querySelector(".iconCloseModal");
    if (iconClose) {
      iconClose.style.display = cp.length > 0 ? "inline-block" : "none";
    }

    if (cp.length !== 5) return;
  } else {
    cp = cookieCP;
  }

  if (window.resetAlertGlobal) window.resetAlertGlobal();

  try {
    let ajaxResponseDias = await ajaxCalculateShipingDays(cp);

    let diasEstimados =
    "<p style='margin: 0;'>Recibe en <strong class='textGreen'>" +
    ajaxResponseDias.diasHabiles +
    "</strong> días hábiles en CP. <strong class='textGreen'>" +
    cp +
    "</strong></p>";
    
    let diasEstimadosGratis =
    "<p style='margin: 0;'>Recibe <strong class='textGreen'>gratis</strong> en <strong>" +
    ajaxResponseDias.diasHabiles +
    "</strong> días hábiles en CP. <strong class='textGreen'>" +
    cp +
    "</strong></p>";

    var precio = getPrecio();
    
    var estadoSinCP = document.getElementById("estadoSinCP");
    var estadoConCP = document.getElementById("estadoConCP");
    var fechaEstimadaElement = document.getElementById("FechaEstimadaEntrega");
    
    if (estadoSinCP) estadoSinCP.style.display = "none";
    if (estadoConCP) estadoConCP.style.display = "flex";
    
    if (fechaEstimadaElement) {
        const diasTexto = `<strong class='textGreen'>${ajaxResponseDias.diasHabiles} días hábiles</strong>`;
        const cpTexto = `<strong class='textGreen'>${cp}</strong>`;
        
        if (precio < 1501) {
            fechaEstimadaElement.innerHTML = `Entrega estimada en ${diasTexto} al CP ${cpTexto}`;
        } else {
            fechaEstimadaElement.innerHTML = `Entrega estimada <strong class='textGreen'>gratis</strong> en ${diasTexto} al CP ${cpTexto}`;
        }
    }
    
    if (alerta) {
      if (precio < 1501) {
        alerta.innerHTML = diasEstimados;
      } else {
        alerta.innerHTML = diasEstimadosGratis;
      }
      alerta.classList.remove("alert-error");
      alerta.classList.add("alert-success");
      alerta.style.display = 'block';
    }

    setInputState("success");

    var formCP = document.querySelector(".formCodigoPostal");
    if (formCP) formCP.style.borderColor = "#004A00";

    var iconPath = document.querySelector(
      ".containerFormCP .icon-doto-search path",
    );
    if (iconPath) iconPath.style.fill = "#004A00";

    window.manejarCookieCodigoPostal(cp);

    if (window.cpGuardado) window.cpGuardado();
  } catch (error) {
    //console.error("Error:", error);
    let errorCP =
      "Ningún envío está disponible para esta zona, verifíca tu código postal.";
    if (alerta) {
      alerta.innerHTML = errorCP;
      alerta.classList.remove("alert-success");
      alerta.classList.add("alert-error");
      alerta.style.display = "block";
    }

    setInputState("error");

    var formCP = document.querySelector(".formCodigoPostal");
    if (formCP) formCP.style.borderColor = "#FF0D00";

    var iconPath = document.querySelector(
      ".containerFormCP .icon-doto-search path",
    );
    if (iconPath) iconPath.style.fill = "#FF0D00";
  }
}

// FUNCIÓN AJAX
function ajaxCalculateShipingDays(cp) {
  return new Promise((resolve, reject) => {
    try {
      let variant_id =
        document.getElementById("variant_id")?.value ||
        document.getElementById("variant_id")?.getAttribute("value");

      if (!variant_id && window.productData?.selectedVariantId) {
        variant_id = window.productData.selectedVariantId;
        //console.log("Variant ID obtenido desde window.productData:", variant_id);
      }

      //console.log("ID de variante encontrado:", variant_id);

      const productSelect = document.getElementById("productSelect");
      //console.log("Elemento productSelect encontrado:", !!productSelect);

      let sku;

      if (window.productData?.variants && variant_id) {
        const variant = window.productData.variants.find(
          (v) => v.id.toString() === variant_id.toString(),
        );
        sku = variant?.sku;
        //console.log("SKU encontrado desde window.productData:", sku);
      }

      if (!sku && productSelect && variant_id) {
        const variantOption = productSelect.querySelector(
          `[value="${variant_id}"]`,
        );
        sku = variantOption?.getAttribute("data-sku");
        //console.log("SKU encontrado desde variantOption (fallback):", sku);
      }

      if (!sku) {
        sku = document.querySelector("[data-sku]")?.getAttribute("data-sku");
        //console.log("SKU encontrado desde data-sku (fallback):", sku);
      }

      if (!sku) {
       // console.error("No se pudo encontrar el SKU del producto");
        reject(new Error("Error al obtener información del producto"));
        return;
      }

      let requestData = {
        zip: cp,
        sku: sku,
        product_id: window.productData?.id || window.currentVariantId,
        variant_id: variant_id,
      };

     // console.log("Datos completos a enviar:", requestData);

      $.ajax({
        url: "https://shipmentsapi.doto.com.mx/api/v1/rates/shopify?pdp=true&shop_id=doto-chingon",
        type: "POST",
        contentType: "application/json",
        data: JSON.stringify(requestData),
        beforeSend: function (xhr) {
         // console.log("Iniciando petición AJAX...");
        },
        success: function (response) {
       // console.log("Respuesta exitosa del servidor:", response);

        if (typeof response === "string") {
            try {
            response = JSON.parse(response);
            } catch (e) {
            //console.error("Error al parsear respuesta:", e);
            }
        }

        if (!Array.isArray(response)) {
            //console.error("La respuesta no es un array:", response);
            reject(new Error("Formato de respuesta inválido"));
            return;
        }

        if (response.length === 0) {
            //console.log("Array de respuesta vacío");
            reject(new Error("No hay servicios de envío disponibles"));
            return;
        }

        //console.log(
        //     "Servicios disponibles:",
        //     response.map((r) => r.tipoServicio),
        // );

        const ahora = new Date();
        const onceAM = new Date();
        onceAM.setHours(11, 0, 0, 0);

        let envioDisponible;
        if (ahora > onceAM) {
            envioDisponible = response.find(
            (envio) => envio.tipoServicio === "Envío Estandar",
            );
        } else {
            envioDisponible =
            response.find(
                (envio) => envio.tipoServicio === "Envío Mismo Día",
            ) ||
            response.find((envio) => envio.tipoServicio === "Envío Estandar");
        }

        if (!envioDisponible) {
            //console.log("No se encontró ningún servicio de envío válido");
            reject(new Error("No hay servicios de envío disponibles"));
            return;
        }

        resolve(envioDisponible);
        },
        error: function (jqXHR, textStatus, errorThrown) {
         // console.error("Error detallado:", {jqXHR, textStatus, errorThrown});
          reject(new Error(`Error en la conexión: ${textStatus}`));
        },
      });
    } catch (error) {
     // console.error("Error en la preparación de la petición:", error);
      reject(error);
    }
  });
}

// FUNCIÓN PARA CARGAR CONTENIDO CP EN POPUP
window.cargarContenidoCPEnPopup = function() {
  var contenidoCP = `
    <div class="containerFormCP">
      <p style="color: #120a00; font-size: 16px; font-style: normal; line-height: 24px; letter-spacing: .08px; padding: 0; margin: 0;">
        <strong>Introduce tu código postal</strong>
      </p>
      <label class="m-0" style="color: #120a00; font-size: 16px; font-style: normal; line-height: 24px; letter-spacing: .08px; padding: 0; margin: 0;">
        Los tiempos pueden variar según el código postal.
      </label>

      <div style="display: flex; align-items: center; justify-content: space-around; gap: 24px; ">
        <div class="formCodigoPostal" id="formCodigoPostal">
          <input 
            type="number"
            step="any"
            name="codigoPostal" 
            placeholder="Código Postal"
            id="cpInput" 
            max="99999"
            style="border: none !important; width: 100%;"
          >
        </div>

        <div style="display: flex; align-items: center; gap: 8px;">
          <!-- SUCCESS icon -->
          <span class="status-icon success" id="iconSuccess" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 14 14" fill="none">
              <path d="M10.9142 4.20575C10.86 4.15108 10.7955 4.10768 10.7244 4.07807C10.6533 4.04845 10.5771 4.0332 10.5001 4.0332C10.423 4.0332 10.3468 4.04845 10.2757 4.07807C10.2046 4.10768 10.1401 4.15108 10.0859 4.20575L5.74005 8.55742L3.91422 6.72575C3.85791 6.67136 3.79145 6.6286 3.71862 6.59989C3.64578 6.57119 3.56801 6.55712 3.48974 6.55847C3.41147 6.55982 3.33423 6.57658 3.26243 6.60779C3.19064 6.63899 3.12569 6.68403 3.0713 6.74034C3.01691 6.79664 2.97415 6.86311 2.94544 6.93594C2.91674 7.00877 2.90267 7.08654 2.90402 7.16481C2.90537 7.24309 2.92213 7.32033 2.95334 7.39212C2.98454 7.46392 3.02958 7.52886 3.08589 7.58325L5.32589 9.82325C5.38011 9.87793 5.44463 9.92132 5.51572 9.95094C5.5868 9.98055 5.66305 9.9958 5.74005 9.9958C5.81706 9.9958 5.8933 9.98055 5.96439 9.95094C6.03547 9.92132 6.09999 9.87793 6.15422 9.82325L10.9142 5.06325C10.9734 5.00863 11.0207 4.94233 11.053 4.86854C11.0853 4.79475 11.102 4.71506 11.102 4.6345C11.102 4.55394 11.0853 4.47426 11.053 4.40047C11.0207 4.32667 10.9734 4.26038 10.9142 4.20575Z" fill="white"/>
            </svg>
          </span>
          
          <!-- ERROR icon-->
          <span class="status-icon error" id="iconError" style="display: none;">
            <svg xmlns="http://www.w3.org/2000/svg" width="35" height="35" viewBox="0 0 14 14" fill="none">
              <path d="M3.94238 10.0583L7.00058 7.0001M7.00058 7.0001L10.0588 3.94189M7.00058 7.0001L3.94238 3.94189M7.00058 7.0001L10.0588 10.0583" stroke="white" stroke-width="0.875" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </span>

          <!-- LOADING icon -->
          <span class="status-icon loading" id="iconLoading" style="display: none;">
            <div class="spinner"></div>
          </span>
        </div>
      </div>
      <p id="alertPopupCP" class="doto-alert text-center m-auto w-100"></p>
      <div class="terms-conditions">
        <p style="color: #696969; font-size: 11px; font-style: italic; font-weight: 500; line-height: 16px; letter-spacing: .055px; margin-top: 8px;">
          *Cualquier duda adicional con envíos, revisa nuestros
          <a href="/pages/terminos-y-condiciones-de-uso" target="_blank" rel="noopener" style="color:#6012c3;">términos y condiciones</a>
        </p>
      </div>
    </div>
  `;
  
  var popupBody = document.getElementById('popup-body-popup-unico');
  if (popupBody) {
    popupBody.innerHTML = contenidoCP;
    
    setTimeout(function() {
      var cpInput = document.getElementById('cpInput');
      if (cpInput) {
        cpInput.addEventListener('keyup', function() {
          if (typeof window.calculaFechaEntrega === 'function') {
            window.calculaFechaEntrega(this);
          }
        });
      }
    }, 100);
  }
};

// FUNCIONES DE RESET MANUAL
window.resetAlertManual = function() {
  var cpInput = document.querySelector("input[name=codigoPostal]");
  if (cpInput) {
    cpInput.value = "";
    cpInput.focus();
  }
  
  var iconClose = document.querySelector(".iconCloseModal");
  if (iconClose) iconClose.style.display = 'none';
  
  if (window.resetAlertGlobal) window.resetAlertGlobal();
};

// INICIALIZACIÓN
function inicializarModalCP() {
 // console.log("Inicializando modal...");
  
  var openModalCPButtons = document.querySelectorAll(".openModalCP");
  
  openModalCPButtons.forEach(function (button) {
    button.addEventListener("click", function (e) {
      e.preventDefault();
      
      if (window.cargarContenidoCPEnPopup) {
        window.cargarContenidoCPEnPopup();
      }
      
      if (window.abrirPopupGenerico) {
        window.abrirPopupGenerico('popup-unico');
      }
      
      if (window.resetAlertGlobal) window.resetAlertGlobal();
    });
  });

  // Cargar cookie al inicio
  var cookieCP = window.manejarCookieCodigoPostal();
  if (cookieCP !== null && typeof calculaFechaEntrega === "function") {
    calculaFechaEntrega(null, cookieCP);
  }
}

// Ejecutar cuando el DOM esté listo
if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", inicializarModalCP);
} else {
  inicializarModalCP();
}

window.calculaFechaEntrega = calculaFechaEntrega;